import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import BackIcon from "../../../assets/icons/icon-back.svg";
import UploadIcon from "../../../images/icon-upload.png";
import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import { Link, useParams } from "react-router-dom";
import { notification } from "antd";
import InputMask from "react-input-mask";
import fetchSiteList from "./../../../api/sites/fetchSiteList";
function PhoneInput(props) {
  return (
    <InputMask
      mask="+1999 999 9999"
      value={props.value}
      onChange={props.onChange}
      placeholder="+1123 123 1234"
      name="phone"
      className="form-control"
    ></InputMask>
  );
}
const UserEdit = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const [getRoles, setRoles] = useState([]);
  const [getSite, setSite] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState(null);
  const [mediaShow, setMediaShow] = useState(false);
  const [phone, setPhone] = useState("");
  const handlePhoneInput = (e) => {
    setPhone(e.target.value);
  };
  useEffect(() => {
    (async () => {
      roleData();
      const siteData = await fetchSiteList();
      if (siteData) {
        setSite(siteData.site_data);
      }
      getUser();
    })();
  }, []);
  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    role: "",
    site: "",
    pin: "",
    status: "",
  });
  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const formSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    formData.append("id", id);
    formData.append("name", credentials.name);
    formData.append("email", credentials.email);
    formData.append("role", credentials.role);
    formData.append("site", credentials.site);
    formData.append("status", credentials.status);
    formData.append("pin", credentials.pin);
    formData.append("phone", phone);
    const response = await fetch(`${url}/api/auth/user/update`, {
      method: "POST",
      body: formData,
    });
    setIsLoading(false);
    const json = await response.json();
    if (json.success) {
      notification.success({
        message: "Success",
        description: "User updated Successfully",
        duration: 3,
      });
    } else {
      notification.error({
        message: "Failed",
        description: json?.error,
        duration: 3,
      });
    }
  };
  const roleData = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      const response = await fetch(`${url}/api/roles/getRoles`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();
      if (json.success) {
        setRoles(json.roles);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getUser = async () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setIsLoading(true);
    const response = await fetch(`${url}/api/auth/user/edit/${id}`, {
      mode: "cors",
      method: "get",
      headers: headers,
    });
    setIsLoading(false);
    const json = await response.json();
    if (json.success) {
      let usr = json.user;
      setCredentials({
        name: usr.name,
        email: usr.email,
        role: usr.role,
        site: usr.site_id,
        status: usr.status,
        pin: usr.pin,
      });
      setPhone(usr.phone);
    } else {
    }
  };
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setMediaShow(false);
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png"];
      if (allowedTypes.includes(file.type)) {
        setFile(file);
        setError(null);
        // Create a FileReader
        const reader = new FileReader();
        // Add a progress event listener to the FileReader
        reader.onprogress = (e) => {
          if (e.lengthComputable) {
            const percentUploaded = Math.round((e.loaded / e.total) * 100);
            setUploadProgress(percentUploaded);
          }
        };
        // Read the file (you can also add other event listeners like 'onload')
        reader.readAsDataURL(file);
      } else {
        setFile(null);
        setError("Invalid file type. Please select an image file.");
        setTimeout(() => {
          setError(null);
        }, 3000);
      }
    }
  };
  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };
  const [isActive, setIsActive] = useState(false);
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/user/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>Edit user</h3>
                  <p>Enter the credentials to add new user to the system</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end"></div>
          </div>
        </div>
        {/* row */}
        <form onSubmit={formSubmit}>
          <div className="form-box card-box">
            <div className="row">
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Name</h4>
                      <p>Enter the precise name of user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="fuserName"
                        placeholder="Stephen"
                        name="name"
                        value={credentials.name}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Email</h4>
                      <p>Enter email address of the user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="email"
                        className="form-control"
                        id="emailadd"
                        placeholder="Email Address"
                        name="email"
                        value={credentials.email}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Phone</h4>
                      <p>Enter the contact number of user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <PhoneInput
                        value={phone}
                        onChange={handlePhoneInput}
                      ></PhoneInput>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>User role</h4>
                      <p>Select the role that the user will play</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="role"
                        value={credentials.role}
                        onChange={handleInput}
                        required
                      >
                        <option value="">Choose Role</option>
                        {getRoles.map((per) => (
                          <option key={per._id} value={per.name}>
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>User Status</h4>
                      <p>Select user status</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="status"
                        value={credentials.status}
                        onChange={handleInput}
                        required
                      >
                        <option value="">Choose Status</option>
                        <option key={1} value={"active"}>
                          Active
                        </option>
                        <option key={2} value={"inactive"}>
                          In Active
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>User site</h4>
                      <p>Select the site for user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="site"
                        value={credentials.site}
                        onChange={handleInput}
                        required
                      >
                        <option value="">Choose Site</option>
                        {getSite.map((per) => (
                          <option
                            key={per._id}
                            value={per._id}
                            selected={per._id === credentials.site}
                          >
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>User pin</h4>
                      <p>Select the pin for user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        name="pin"
                        value={credentials.pin}
                        onChange={handleInput}
                        placeholder="1234..."
                      ></input>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Picture</h4>
                      <p>Upload the clear picture of user</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <div className="file-wrap">
                        <input type="file" onChange={handleFileSelect} />
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="file_name">
                            {file ? file.name : "No file selected"}
                          </span>{" "}
                          <img src={UploadIcon} alt="Upload Icon" />
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "red",
                          fontStyle: "italic",
                        }}
                      >
                        {uploadProgress > 0 && uploadProgress < 100 && (
                          <span>{uploadProgress}% uploaded</span>
                        )}
                      </div>
                      {error && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "red",
                            fontStyle: "italic",
                          }}
                        >
                          {error}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-12 text-end">
                <div className="form-btn-wrap mb-5 pb-5">
                  <button
                    type="submit"
                    disabled={isLoading}
                    href=""
                    className="btn btn-prim w-auto ms-5"
                  >
                    <i className="fa fa-spinner fa-spin" style={iocnStyle}></i>{" "}
                    Update User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default UserEdit;
